module.exports = __webpack_public_path__ + "media/ppc/soldier-holding-radio-43aadbd3.jpg";